import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CustomerValidationComponent } from './customer-validation.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerValidationComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerValidationRoutingModule {}
